import { observer } from 'mobx-react';
import React from 'react';

import {
  Paginated
} from '../../../../adl-gen/common';
import {
  DbKey,
  WithDbId
} from '../../../../adl-gen/common/db';
import { Competency, Skill } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { Loader } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { ListEntryWithIdentity } from '../../common/list/list-types';
import { CompetencyStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { CompetencyForm } from '../../components/forms/competency-form/competency-form';
import { CompetencyDetailsView } from '../../components/detail-views/competency-details-view';

interface CompetencyDetailScreenProps {
  pageLayout: AdminPageLayoutFn;
  navigateTo(route: Route): void;
  mode?: FormMode;

  store: CompetencyStore;

  onCancel?(): Promise<void>;
  onUpdate?(competencyId: DbKey<Competency>): Promise<void>;
}

@observer
export class CompetencyDetailScreen extends React.Component<CompetencyDetailScreenProps> {

  onSelectSkill = async (skillId: DbKey<Skill>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'skill',
      id: skillId
    });
  };

  onCreateSkill = () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'skill',
      view: 'new'
    });
  };

  renderCompetencyDetails = observer((data: Paginated<ListEntryWithIdentity<Skill>>) => {
    const { onUpdate, store } = this.props;

    if (!store.isSuperUser) {
      throw Error('Not authorized');
    }

    const competency = store.selected;

    if (competency && competency.kind === 'value' && onUpdate) {
      return (
        <CompetencyDetailsView
          competency={competency.value}
          skills={data}
          onUpdate={onUpdate}
          onCreateSkill={this.onCreateSkill}
          onSelectSkill={this.onSelectSkill}
          role={'super'}
        />
      );
    } else {
      return null;
    }
  });

  renderCreateCompetencyForm = observer(() => {
    const { mode, onCancel, store } = this.props;

    if (onCancel) {
      return (
        <CompetencyForm
          store={store}
          mode={mode}
          onCancel={onCancel}
          // TODO: Remove this?
          isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  renderUpdateCompetencyForm = observer((competency: WithDbId<Competency>) => {
    const { mode, onCancel, store } = this.props;

    if (onCancel) {
      return (
        <CompetencyForm
          item={competency}
          // userData={userData}
          store={store}
          mode={mode}
          onCancel={onCancel}
          // TODO: Remove this?
          isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  CompetencyDetailsLoader = () => {
    const { store, mode } = this.props;
    const competency = store.selected;
    if (competency) {
      if (mode === 'update' || mode === 'delete') {
        return <Loader state={competency} LoadedComponent={this.renderUpdateCompetencyForm} />;
      } else {
        /// View
        return <Loader state={store.skillData} LoadedComponent={this.renderCompetencyDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <this.renderCreateCompetencyForm />;
    }
  };

  render() {
    return (
      <this.props.pageLayout title={'Administration - Competency'}>
        <this.CompetencyDetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/competency-detail-screen/competency-detail-screen.tsx